import React, { useCallback, useMemo, useContext } from 'react';
import { IconButton } from '@fedsim/components';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// import Brightness4Icon from '@mui/icons-material/Brightness4';
// import Brightness7Icon from '@mui/icons-material/Brightness7';

import Brightness7Icon from '@mui/icons-material/WbIncandescentOutlined';
import Brightness4Icon from '@mui/icons-material/WbIncandescent';

import { components, lightPalette, darkPalette } from 'theme/theme'
import useGame from 'hooks/useGame';

export const ColorModeContext = React.createContext({ mode: 'light', toggleColorMode: () => { } });

export function ToggleMode() {
  const colorMode = useContext(ColorModeContext);
  return (
    <IconButton sx={{ ml: 1 }} onClick={colorMode.toggleColorMode} color="inherit">
      {colorMode.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  );
}

export function ToggleColorMode({ children = null }) {
  const { model, onUpdate } = useGame() || {}
  const { dark = 'dark' } = model || {}
  const mode = dark

  const onToggleMode = useCallback(() => onUpdate({ dark: mode === 'dark' ? 'light' : 'dark' }), [mode, onUpdate])

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () => {
        onToggleMode()
      },
    }),
    [mode, onToggleMode],
  );

  const theme = React.useMemo(
    () =>
      createTheme({
        components,
        palette: {
          mode,
          ...(mode === 'dark' ? darkPalette : lightPalette),
        }
      }),
    [mode],
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default ToggleColorMode
